import React, { Component } from 'react';
import { connect } from 'react-redux';
import { stringify as qsStringify } from 'querystring';
import { linkSubscribe } from '../../../conf/config';


import firebaseApp from './../../../utils/firebase/firebase';
import SingletonLibrary from './../../../library/SingletonLibrary';

//-- Actions

//-- Common
import Zigzag from './../../../containers/UI/Common/Shapes/Zigzag';

//-- Containers
import Modal from '../../UI/Modal/Modal';

//-- Utils
import * as staticsTool from './../../../utils/url/staticUrl';
import Aux from './../../../hoc/_Aux';

class ProductDetails extends Component {
    state = {
        currentProduct: null,
        error: false,
        errorMessage: '',
        showModal: false,
        modalStep: 0,
        remainingPoints : 0
    }
    /*****************************
     * Override component methods *
     *****************************/
    componentDidMount = () => {
        this.setState({
            currentProduct : this.props.products[this.props.position]
        });
    }

    /*************************
     *         Handler       *
     *************************/

    modalShowHandler = () => {
        
        let remainingPointsAfterSale = 0; 
        if(this.state.modalStep===0){
            if(this.state.currentProduct!==null){
                remainingPointsAfterSale = this.props.userAvailablePoints - this.state.currentProduct.price;
            }
        }
        
        this.setState({
            showModal: true,
            remainingPoints : remainingPointsAfterSale  
        });
    }

    modalCancelHandler = () => {
        this.setState({
            showModal: false, 
        });
    }
    modalAbonnementLink = (event) => {
        event.preventDefault();
        window.open(linkSubscribe, '_blank');
    }

    modalNextStepClickHandler = (event) => {
        event.preventDefault();
        const direction = event.target.getAttribute('data-dir');
        let modalIsShown = false;
        let error = false;
        let errorMessage = '';
        let currentStep = this.state.modalStep;
      
        if(currentStep===0){
            if(direction < 0){
                modalIsShown = false;
            }else{
                currentStep++;
                modalIsShown = true;

                firebaseApp.auth().currentUser.getIdToken()
                .then((fbIdToken) => {

                    const formData = {
                        productId: this.state.currentProduct.product_id
                    };
    
                    return SingletonLibrary
                        .getAxiosInstance
                        .post('/store/order',qsStringify(formData),
                        {
                            headers: {
                                'Content-Type': 'application/x-www-form-urlencoded',
                                'fbkm-access-token':fbIdToken
                            }
                        });
                })
                .catch((err) => {

                    error = true;
                    errorMessage = 'Oups il semblerait que nous ayons rencontré une erreur';
                    
                    this.setState({
                        modalStep: currentStep,
                        showModal: modalIsShown,
                        error,
                        errorMessage
                    });
                });
            }
        }else if(currentStep===1){
            this.props.backToList();  
            modalIsShown = false;
        }
        
        this.setState({
            modalStep: currentStep,
            showModal: modalIsShown,
            error,
            errorMessage
        });
    }

    /*************************
     *    Custom carousel    *
     *************************/

    render = () => {
        let bgProduct = null;
        let titleProduct = "";
        let priceProduct = 0;
        let htmlContent = "";
        let modalOutput =  null;

        const cp = this.state.currentProduct;
        if ( this.state.currentProduct !== null ) {
            bgProduct = {'background': `url('${staticsTool.getFirstAsset('media/km/xlarge/'+this.state.currentProduct.img_url)}') 50% 50% / cover no-repeat`};
            titleProduct = cp.title;
            priceProduct = cp.price;
            htmlContent = cp.content_html;

        }
        
        let modalCommonHeader = (
            <Aux>
                <span className="gift-icon" />
                <h4>{titleProduct}</h4>
            </Aux>
        )
        var modalClass = 'product-modal';
        if(this.state.remainingPoints >= 0) {
            if(this.state.modalStep===0){
                modalOutput = (
                    <Aux>
                        {modalCommonHeader}
                        <h3>Es tu sûr?</h3>
                        <p>Tu n'auras plus que {this.state.remainingPoints} points si tu passes cette commande</p>
                        <div className="action-btn">
                            <div className="cancel" data-dir="-1" onClick={ (event) => {this.modalNextStepClickHandler(event)}}>Non</div>
                            <div className="ok" data-dir="1" onClick={ (event) => {this.modalNextStepClickHandler(event)}}>Oui</div>
                        </div>
                    </Aux>
                );
            }else if(this.state.error){
                modalOutput = (
                    <Aux>
                        {modalCommonHeader}
                        <p>{this.state.errorMessage}</p>
                        <div className="action-btn one-btn">
                            <div className="confirm" data-dir="1" onClick={ (event) => {this.modalNextStepClickHandler(event)}}>Retour boutique</div>
                        </div>
                    </Aux>
                );
            }
            else{
                modalOutput = (
                    <Aux>
                        {modalCommonHeader}
                        <p>Un mail a été envoyé à tes parents pour qu'ils puissent valider la commande</p>
                        <div className="action-btn one-btn">
                            <div className="confirm" data-dir="1" onClick={ (event) => {this.modalNextStepClickHandler(event)}}>Retour boutique</div>
                        </div>
                    </Aux>
                );
            }
        }else if(this.state.remainingPoints < 0){
            modalOutput = (
                <Aux>
                    {modalCommonHeader}
                    <h3>Pas si vite</h3>
                    <p>Tu n'as pas assez de points pour choisir cette commande</p>
                    <div className="action-btn one-btn">
                        <div className="return" data-dir="-1" onClick={ (event) => {this.modalNextStepClickHandler(event)}}>Retour</div>
                    </div>
                </Aux>
            );  
        }
        else {
            modalClass = 'trial-boutique';
            modalOutput = (
              <Aux>
                <div className="close-button" onClick={this.modalCancelHandler}></div>
                <div className="image"></div>
                <p className="big-text">Tu as vu un cadeau sympa?</p>
                <p className="small-text">Il faut être abonné pour commander dans la boutique</p>
              </Aux>
            );
        }

        return <div className="details-product-viewport" >
                    <div className="product-container" >
                        <span className="back-to-list" onClick={this.props.backToList} />
                        <div className="image" style={bgProduct} />
                        <span className="action-buy" onClick={this.modalShowHandler}>Je le veux !!!</span>
                        <div className="details-content">
                            <div className="title-header"> 
                                <span className="title">{titleProduct}</span>
                                <span className="cost">{priceProduct}</span>
                            </div>
                            <div className="description" dangerouslySetInnerHTML={{__html: htmlContent}} />
                        </div>
                    </div>
                    <Modal show={this.state.showModal} modalClosed={this.modalCancelHandler} class={modalClass}>
                        <div className="modal-container">
                            {/*
                            <div className="close-button" onClick={this.modalCancelHandler}></div>*/}
                            
                            {modalOutput}
                        </div>
                    </Modal>
                    <div className="shape shape-top">
                        <Zigzag color="#ffde39" translateXaxis="-10" />
                    </div>
                    <div className="shape shape-bottom">
                        <Zigzag color="#fd8598" translateXaxis="10" />
                    </div>
                </div>;
                
    }
}

const mapStateToProps = state => {
    return {
        products: state.datasStore.products,
        position: state.datasStore.targetedProduct,
        userAvailablePoints : state.points.currentPoints
    }
};

export default connect( mapStateToProps, null )(ProductDetails);


// WEBPACK FOOTER //
// ./src/components/StorePage/ProductDetails/ProductDetails.js